module.exports = __webpack_public_path__ + "img/sportstradeheadersection.c6fd19b5.png";